module.exports = __webpack_public_path__ + "static/media/Print-blue.12721d78.svg";